/* ============================================================
   Fiber Snob — Swatch Tray
   Add to: assets/swatch-tray.js

   SETUP REQUIRED:
   1. Create a "Fabric Swatch Pack" product in Shopify admin, priced at $5.00
   2. Go to that product → copy the variant ID from the URL or via Shopify admin
   3. Replace REPLACE_WITH_YOUR_VARIANT_ID below with that number
   ============================================================ */

(function () {
  'use strict';

  /* ── Config ── */
  var SWATCH_PACK_VARIANT_ID = '63594855170417'; // e.g. '1234567890123'
  var STORAGE_KEY = 'fibersnob_swatches';
  var MAX_SWATCHES = 5;
  var AUTO_CLOSE_MS = 2600;

  var autoCloseTimer = null;

  /* ────────────────────────────────────────────
     Storage helpers
  ──────────────────────────────────────────── */
  function getSwatches() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveSwatches(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) { /* storage unavailable */ }
  }

  function addSwatch(swatch) {
    var swatches = getSwatches();
    if (swatches.length >= MAX_SWATCHES) return false;
    if (swatches.some(function (s) { return String(s.id) === String(swatch.id); })) return false;
    swatches.push(swatch);
    saveSwatches(swatches);
    return true;
  }

  function removeSwatch(id) {
    var swatches = getSwatches().filter(function (s) {
      return String(s.id) !== String(id);
    });
    saveSwatches(swatches);
  }

  /* ────────────────────────────────────────────
     Tray open / close
  ──────────────────────────────────────────── */
  function openTray() {
    var tray = document.getElementById('swatch-tray');
    var tab  = document.getElementById('swatch-tab');
    if (!tray) return;
    tray.classList.add('is-open');
    if (tab) tab.setAttribute('aria-expanded', 'true');
  }

  function closeTray() {
    var tray = document.getElementById('swatch-tray');
    var tab  = document.getElementById('swatch-tab');
    if (!tray) return;
    tray.classList.remove('is-open');
    if (tab) tab.setAttribute('aria-expanded', 'false');
  }

  function scheduleAutoClose() {
    clearTimeout(autoCloseTimer);
    autoCloseTimer = setTimeout(closeTray, AUTO_CLOSE_MS);
  }

  /* ────────────────────────────────────────────
     Render
  ──────────────────────────────────────────── */
  function renderTray() {
    var swatches   = getSwatches();
    var count      = swatches.length;
    var isFull     = count >= MAX_SWATCHES;

    /* Count badge on tab */
    var tabCounts = document.querySelectorAll('.swatch-tab-count');
    tabCounts.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });

    /* "N of 5 selected" */
    var selectedCountEl = document.getElementById('swatch-selected-count');
    if (selectedCountEl) selectedCountEl.textContent = count;

    /* Empty state */
    var emptyEl = document.getElementById('swatch-tray-empty');
    if (emptyEl) emptyEl.style.display = count === 0 ? 'block' : 'none';

    /* Checkout button */
    var checkoutBtn = document.getElementById('swatch-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.classList.toggle('is-visible', count > 0);
    }

    /* Swatch list */
    var listEl = document.getElementById('swatch-tray-list');
    if (listEl) {
      listEl.innerHTML = swatches.map(function (s) {
        var imgHtml = s.image
          ? '<img src="' + s.image + '" alt="' + escapeAttr(s.title) + '" class="swatch-item-img" loading="lazy">'
          : '<div class="swatch-item-img swatch-item-img--placeholder" aria-hidden="true"></div>';

        return '<li class="swatch-item">'
          + imgHtml
          + '<span class="swatch-item-title">' + escapeHTML(s.title) + '</span>'
          + '<button class="swatch-item-remove" data-remove-id="' + escapeAttr(String(s.id)) + '" aria-label="Remove ' + escapeAttr(s.title) + '">&#x2715;</button>'
          + '</li>';
      }).join('');
    }

    /* Add-swatch buttons across the page */
    updateAddButtons(swatches, isFull);
  }

  function updateAddButtons(swatches, isFull) {
    swatches = swatches || getSwatches();
    isFull   = (isFull !== undefined) ? isFull : swatches.length >= MAX_SWATCHES;
    var ids  = swatches.map(function (s) { return String(s.id); });

document.querySelectorAll('[data-swatch-btn]').forEach(function (btn) {
  var id      = String(btn.dataset.swatchKey || btn.dataset.productId);
  var added   = ids.indexOf(id) !== -1;
  var soldOut = btn.dataset.soldOut === 'true';

  btn.classList.toggle('swatch-request-btn--added', added);

  if (soldOut) {
    btn.disabled = true;
    btn.textContent = 'Out of Stock';
    btn.title = 'This variant is not available';
  } else if (added) {
    btn.disabled = true;
    btn.textContent = '✓ Swatch Added';
    btn.title = '';
  } else if (isFull) {
    btn.disabled = true;
    btn.textContent = 'Tray Full';
    btn.title = 'Remove a swatch to add another';
  } else {
    btn.disabled = false;
    btn.textContent = 'Request Swatch';
    btn.title = '';
  }
});
  }

  /* ────────────────────────────────────────────
     Checkout
  ──────────────────────────────────────────── */
  function requestSwatches() {
    var swatches = getSwatches();
    if (swatches.length === 0) return;

    var checkoutBtn = document.getElementById('swatch-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.textContent = 'Adding to cart…';
      checkoutBtn.disabled = true;
    }

    /* Build line item properties — one per swatch */
    var properties = {};
   swatches.forEach(function (s, i) {
  properties['Swatch ' + (i + 1)]              = s.title;
  if (s.image)     properties['_Swatch ' + (i + 1) + ' Image']   = s.image;
  if (s.handle)    properties['_Swatch ' + (i + 1) + ' Handle']  = s.handle;
  if (s.variantId) properties['_Swatch ' + (i + 1) + ' Variant'] = s.variantId;
  
});

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: SWATCH_PACK_VARIANT_ID,
        quantity: 1,
        properties: properties
      })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      /* Clear tray and go to cart */
      saveSwatches([]);
      renderTray();
      closeTray();
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error('Swatch cart error:', err);
      if (checkoutBtn) {
        checkoutBtn.textContent = 'Request Swatches — $5.00';
        checkoutBtn.disabled = false;
      }
      var msg = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
      alert(msg);
    });
  }

  /* ────────────────────────────────────────────
     Event delegation — one listener handles all
  ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {

    /* Add swatch */
   var addBtn = e.target.closest('[data-swatch-btn]');
if (addBtn) {
  var swatch = {
    id:        addBtn.dataset.swatchKey || addBtn.dataset.productId,
    title:     addBtn.dataset.productTitle,
    image:     addBtn.dataset.productImage || null,
    handle:    addBtn.dataset.productHandle || null,
    variantId: addBtn.dataset.variantId || null
  };
      var added = addSwatch(swatch);
      if (added) {
        renderTray();
        openTray();
        scheduleAutoClose();
      }
      return;
    }

    /* Remove swatch */
    var removeBtn = e.target.closest('[data-remove-id]');
    if (removeBtn) {
      removeSwatch(removeBtn.dataset.removeId);
      renderTray();
      return;
    }

    /* Tab toggle */
    if (e.target.closest('#swatch-tab')) {
      clearTimeout(autoCloseTimer);
      var tray = document.getElementById('swatch-tray');
      if (tray && tray.classList.contains('is-open')) {
        closeTray();
      } else {
        openTray();
      }
      return;
    }

    /* Checkout */
    if (e.target.closest('#swatch-checkout-btn')) {
      requestSwatches();
      return;
    }

    /* Click outside → close */
    var trayEl = document.getElementById('swatch-tray');
    if (trayEl && trayEl.classList.contains('is-open') && !trayEl.contains(e.target)) {
      clearTimeout(autoCloseTimer);
      closeTray();
    }

  });

  /* Keyboard: Escape closes tray */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      clearTimeout(autoCloseTimer);
      closeTray();
    }
  });

  function initVariantTracking() {
  var variantDataEl = document.getElementById('swatch-product-variants');
  if (!variantDataEl) return;

  var variants;
  try {
    variants = JSON.parse(variantDataEl.textContent);
  } catch (e) { return; }

  var variantInput = document.querySelector('input.product-variant-id');
  if (!variantInput) return;

  function updateBtn(variantId) {
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) {
        variant = variants[i];
        break;
      }
    }
    if (!variant) return;

    var btn = document.querySelector('.swatch-request-btn--pdp[data-swatch-btn]');
    if (!btn) return;

    /* Store base product title on first run */
    if (!btn.dataset.baseTitle) {
      btn.dataset.baseTitle = btn.dataset.productTitle;
    }

    /* Append variant title unless it's the default single-variant placeholder */
if (variant.title && variant.title !== 'Default Title') {
  btn.dataset.productTitle = btn.dataset.baseTitle + ' \u2014 ' + variant.title;
} else {
  btn.dataset.productTitle = btn.dataset.baseTitle;
}

/* Update the swatch key to this specific variant, then re-check button state */
btn.dataset.swatchKey = btn.dataset.productId + '-' + variantId;
btn.dataset.variantId = variantId;
btn.dataset.soldOut = variant.available ? 'false' : 'true';
updateAddButtons();

    /* Update image to variant image if available */
    if (variant.featured_image && variant.featured_image.src) {
      btn.dataset.productImage = variant.featured_image.src;
    }
  }

  /* Watch for Dawn updating the hidden variant input */
  new MutationObserver(function() {
    updateBtn(variantInput.value);
  }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });

  variantInput.addEventListener('change', function() {
    updateBtn(this.value);
  });

  /* Set initial state */
  updateBtn(variantInput.value);
}

  /* ────────────────────────────────────────────
     Init
  ──────────────────────────────────────────── */
 if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    renderTray();
    initVariantTracking();
  });
} else {
  renderTray();
  initVariantTracking();
}

  /* ────────────────────────────────────────────
     Helpers
  ──────────────────────────────────────────── */
  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return String(str).replace(/"/g, '&quot;');
  }

  /* Expose for external use (e.g. from theme sections) */
  window.FiberSnobSwatches = {
    add:    addSwatch,
    remove: removeSwatch,
    get:    getSwatches,
    render: renderTray
  };

}());
